import script from "./CustomerTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerTable.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerTable.vue?vue&type=style&index=0&id=394abb28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394abb28"]])

export default __exports__